<template>
<div>
    <h3>华源网络营销中心简介</h3>
    <ul>
        <li>
            <p>
                安徽华源医药股份有限公司作为北京汉宁恒丰医药科技股份有限公司重要的合作伙伴，自2010年双方签订医药电子商务战略框架协议起，就一直保持着深度战略合作关系。安徽华源医药给予北京汉宁恒丰充分资源和政策支持，合作之初，便成立安徽华源网络营销中心，作为双方战略合作的执行机构， 由北京汉宁恒丰医药科技股份有限公司太和分公司承担中心的所有职能，专门为平台华源订单采购客户提供的客户服务及物流服务。
            </p>
            <p></p><center><img src="@/assets/20190724.jpg" width="706" height="485"></center><p></p>
            <p>
                华源网络营销中心运营至今，始终秉承“以客户为中心，用专业优质的服务，为客户创造独特价值”为经营理念，通过持续不断的业务创新与改进，为广大药聚多客户提供高品质的产品和服务，获得了众多客户及同行的称赞与认可。
            </p>
            <p>
                目前，华源网络营销中心辖属六大业务部门，分别为：物流中心、商务中心、客服中心、业务拓展部、综合部以及财务部，拥有员工一百余人。
            </p>
            <p>
                未来，我们仍将高度重视用户体验，持续为药聚多客户带来更加优质、便捷、贴心的服务。
            </p>
        </li>
    </ul>
</div>
</template>
<script>
export default {
  name: 'Yxzx'
}
</script>
